import { Block, Flex } from '@aloft/toolkit-sui';

import { useScrollToAnchor } from '../../hooks/useScrollToAnchor.tsx';
import { DepreciatedCost } from './DepreciatedCost/DepreciatedCost.tsx';
import { MarketAdjustments } from './MarketAdjustments/MarketAdjustments.tsx';
import { Methodology } from './Methodology.tsx';
import { SiteExtraction } from './SiteExtraction/SiteExtraction.tsx';

import './CommentaryModule.scss';

export const CommentaryModule = () => {
  useScrollToAnchor();

  return (
    <Block overflow="auto" height="100%" width="100%" backgroundColor="surface1">
      <Flex>
        <Flex flexDirection="column" gap={8} paddingX={8} paddingY={4} maxWidth="100%">
          <DepreciatedCost />
          <SiteExtraction />
          <MarketAdjustments />
          <Methodology />
        </Flex>
      </Flex>
    </Block>
  );
};
